import type { Customer, LimitType, PaymentDate, PartnerSnapshot } from '@shared/types';

/**
 * 顧客マスタから受注用の顧客スナップショットを生成する（Mr.販管「依頼元」仕様）。
 *
 * 受注時点の宛先・締め/支払を凍結保存し、後のマスタ変更（社名改称・担当退職・吸収合併）に
 * 影響されないようにするためのdenormalizedコピー。customerId は別途保持されるため、
 * これはあくまで表示・帳票用の補助データ。
 *
 * Firestore は undefined を許容しないため、値が無い任意項目はキーごと省略する。
 */
export function buildCustomerSnapshot(
  customer: Customer,
  limitTypeName?: string,
  paymentDateName?: string,
): PartnerSnapshot {
  const snap: PartnerSnapshot = {
    name: customer.name,
    furi: customer.nameKana,
    masterCode: customer.code,
    zip: customer.postalCode,
    prefecture: customer.prefecture,
    addr1: customer.addr1,
    addr2: customer.addr2,
    addr3: customer.addr3,
    organize: customer.department ?? '',
    tel: customer.phone,
  };
  if (customer.tel2) snap.tel2 = customer.tel2;
  if (customer.fax) snap.fax = customer.fax;
  if (limitTypeName) snap.limitType = limitTypeName;
  if (paymentDateName) snap.paymentDate = paymentDateName;
  return snap;
}

/**
 * 締め日・支払日マスタを名称解決した上でスナップショットを生成する。
 */
export function snapshotFromMasters(
  customer: Customer,
  limitTypes: LimitType[],
  paymentDates: PaymentDate[],
): PartnerSnapshot {
  const limitTypeName = limitTypes.find((l) => l.id === customer.limitTypeId)?.name;
  const paymentDateName = paymentDates.find((p) => p.id === customer.paymentDateId)?.name;
  return buildCustomerSnapshot(customer, limitTypeName, paymentDateName);
}
